import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconType, IoniconsOutline, PermissionDialog, PtEntity } from '@pt/pt-models';
import { ID_PAGE, ResolutionChecker } from '../../utils';
import { ReminderPayload } from '../details';

@Component({
  selector: 'pt-table-page-layout',
  template: `
    <ng-sidebar-container class='ng-sidebar-container-detail' [id]='ID'>
      <ng-sidebar
        [(opened)]='opened'
        [mode]="'over'"
        [dock]='false'
        [animate]='true'
        [keyClose]='false'
        [autoFocus]='true'
        [trapFocus]='false'
        [position]="'right'"
        [showBackdrop]='false'
        [ariaLabel]="'sidebar'"
        [autoCollapseWidth]='null'
        [autoCollapseHeight]='null'
        [closeOnClickOutside]='true'
        [closeOnClickBackdrop]='false'
        [sidebarClass]='"ng-sidebar--custom ng-sidebar--custom--details " + (extended ? "full" : "")'
        (onClosed)='clickClose.emit()'>
        <div class='h-100 panel-details-container' [class.d-none]="!opened">
          <pt-details-page-header
            [title]='title'
            [entity]='entity'
            [description]='description'
            [extended]='extended'
            [opened]="opened"
            [reminderBtnType]="reminderBtnType"
            [btnText]="btnText"
            [reminderPayload]="reminderPayload"
            [showBtnReminderText]="showBtnReminderText"
            [permissionDialog]="permissionDialog"
            (clickClose)='onClickClose()'
            (clickRefresh)='clickRefresh.emit()'
            (clickFitContainer)='onClickFitContainer()'>
            <ng-content detailHeaderAlertContent select='[detailHeaderAlertContent]'></ng-content>
            <ng-content additionalDetailTitleContent select='[additionalDetailTitleContent]'></ng-content>
          </pt-details-page-header>
          <div class='body-panel' id="detailPageId" [style.min-width]="bodyPanelMinWidth"
               [ngClass]="{'body-panel--extended': extended}">
            <ng-content select='[pageDetail]'></ng-content>
          </div>
        </div>
      </ng-sidebar>

      <div ng-sidebar-content class='page-content'>
        <div class="pageContentLoader" *ngIf="loading">
          <div class='spinner-border' style="width: 25px; height: 25px;" role='status'>
            <span class='visually-hidden'>Loading...</span>
          </div>
        </div>
        <ng-content select='[pageContent]'></ng-content>
      </div>
    </ng-sidebar-container>
  `,
  styleUrls: ['./table-page-layout.component.scss']
})
export class TablePageLayoutComponent {

  @Input() opened = false;
  @Input() title: string;
  @Input() entity: PtEntity;
  @Input() description: string;

  @Input() showBtnReminderText = true;
  @Input() reminderBtnType: 'btn' | 'flat' = 'btn';
  @Input() btnText = 'BUTTON.ADD_REMINDER';
  @Input() reminderPayload?: ReminderPayload;
  @Input() permissionDialog?: PermissionDialog;
  @Input() loading = false;


  @Output() clickClose = new EventEmitter();
  @Output() clickRefresh = new EventEmitter();

  extended = false;
  ID = ID_PAGE;
  IconClose = IoniconsOutline.close;
  iconType = IconType.IONIC_ICON;
  bodyPanelMinWidth = '410px'; // valore calcolato in base alla risuluzione 1280

  onClickFitContainer() {
    this.extended = !this.extended;
    const scaleValue = ResolutionChecker.getScaleValue(document.documentElement.clientWidth);
    if (this.extended && scaleValue < 1) {
      this.bodyPanelMinWidth = (document.documentElement.clientWidth - (280 * scaleValue)) / scaleValue + 'px';
    } else {
      this.bodyPanelMinWidth = '410px'; // valore calcolato in base alla risuluzione 1280
    }
  }

  onClickClose() {
    this.extended = false;
    this.clickClose.emit();
  }
}
